import React from 'react'
import tw, { styled } from 'twin.macro'
import { useStateContext } from '../context/stateContext'
import { motion } from 'framer-motion'

const Container = styled(motion.div)`
	${tw`absolute z-20 items-center justify-center w-10 h-10 cursor-pointer`}
`
const Sound = ({ mode, mobile }) => {
	const stateContext = useStateContext()

	const toggleSound = (state) => {
		stateContext.dispatch({ action: 'SET_SOUND', data: state })
		state ? stateContext.unmuteSound() : stateContext.muteSound()
	}

	return (
		<Container
			className={mode === 'game' ? 'flex right-5 sm:right-10 top-1/2 transform -translate-y-1/2' : mobile ? 'top-2 right-5 flex md:hidden' : 'hidden md:flex top-4 right-10'}
			onClick={() => {
				toggleSound(!stateContext.state.sound)
			}}
		>
			{stateContext.state.sound && (
				<svg className='w-[35px] h-[35px]' xmlns='http://www.w3.org/2000/svg' width='42' height='42' viewBox='0 0 42 42' fill='none'>
					<path
						d='M24.5 36.2686V32.6811C27.125 31.9227 29.2396 30.4644 30.8438 28.3061C32.4479 26.1477 33.25 23.6977 33.25 20.9561C33.25 18.2144 32.4479 15.7644 30.8438 13.6061C29.2396 11.4477 27.125 9.98939 24.5 9.23105V5.64355C28.1167 6.46022 31.0625 8.29043 33.3375 11.1342C35.6125 13.9779 36.75 17.2519 36.75 20.9561C36.75 24.6602 35.6125 27.9342 33.3375 30.7779C31.0625 33.6217 28.1167 35.4519 24.5 36.2686ZM5.25 26.2498V15.7498H12.25L21 6.9998V34.9998L12.25 26.2498H5.25ZM24.5 27.9998V13.9123C25.8708 14.554 26.9427 15.5165 27.7156 16.7998C28.4885 18.0831 28.875 19.4831 28.875 20.9998C28.875 22.4873 28.4885 23.8654 27.7156 25.1342C26.9427 26.4029 25.8708 27.3581 24.5 27.9998ZM17.5 15.4873L13.7375 19.2498H8.75V22.7498H13.7375L17.5 26.5123V15.4873Z'
						fill='white'
					/>
				</svg>
			)}
			{!stateContext.state.sound && (
				<svg className='w-[29px] h-[29px]' style={{ margin: '1px 1px 0px 0px' }} xmlns='http://www.w3.org/2000/svg' width='23' height='23' viewBox='0 0 23 23' fill='none'>
					<path
						d='M21.275 22.4254L17.8719 19.0223C17.4031 19.3223 16.9062 19.5801 16.3812 19.7957C15.8562 20.0113 15.3125 20.1848 14.75 20.316V18.0098C15.0125 17.916 15.2703 17.8223 15.5234 17.7285C15.7766 17.6348 16.0156 17.5223 16.2406 17.391L12.5 13.6504V19.5004L6.875 13.8754H2.375V7.12539H5.975L0.574997 1.72539L2.15 0.150391L22.85 20.8504L21.275 22.4254ZM21.05 15.9004L19.4188 14.2691C19.7375 13.6879 19.9766 13.0785 20.1359 12.441C20.2953 11.8035 20.375 11.1473 20.375 10.4723C20.375 8.70977 19.8594 7.13477 18.8281 5.74727C17.7969 4.35977 16.4375 3.42227 14.75 2.93477V0.628516C17.075 1.15352 18.9688 2.33008 20.4312 4.1582C21.8938 5.98633 22.625 8.09102 22.625 10.4723C22.625 11.466 22.4891 12.4223 22.2172 13.341C21.9453 14.2598 21.5562 15.1129 21.05 15.9004ZM17.2812 12.1316L14.75 9.60039V5.94414C15.6312 6.35664 16.3203 6.97539 16.8172 7.80039C17.3141 8.62539 17.5625 9.52539 17.5625 10.5004C17.5625 10.7816 17.5391 11.0582 17.4922 11.3301C17.4453 11.602 17.375 11.8691 17.2812 12.1316ZM12.5 7.35039L9.575 4.42539L12.5 1.50039V7.35039ZM10.25 14.0441V11.4004L8.225 9.37539H4.625V11.6254H7.83125L10.25 14.0441Z'
						fill='white'
					/>
				</svg>
			)}
		</Container>
	)
}

export default Sound
